import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import AppShell from './App';
import DashboardPage from './pages/DashboardPage';
import BacktestsPage from './pages/BacktestsPage';
import DataIndexPage from './pages/DataIndexPage';
import StrategiesPage from './pages/StrategiesPage';
import LoginPage from './pages/LoginPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import UsersPage from './pages/UsersPage';
import SetupPage from './pages/SetupPage';
import { AdminOnly, GuestOnly, RequireAuth, RequirePasswordChanged, SetupOnly } from './components/auth/RouteGuards';

const DatasetDetailPage = lazy(() => import('./pages/DatasetDetailPage'));
const BacktestDetailPage = lazy(() => import('./pages/BacktestDetailPage'));
const StrategyBuilderPage = lazy(() => import('./pages/StrategyBuilderPage'));
const datasetDetailElement = (
  <Suspense fallback={<p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>Loading dataset...</p>}>
    <DatasetDetailPage />
  </Suspense>
);
const backtestDetailElement = (
  <Suspense fallback={<p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>Loading backtest...</p>}>
    <BacktestDetailPage />
  </Suspense>
);
const strategyBuilderElement = (
  <Suspense fallback={<p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>Loading strategy editor...</p>}>
    <StrategyBuilderPage />
  </Suspense>
);

export const routes: RouteObject[] = [
  {
    path: '/setup',
    element: <SetupOnly><SetupPage /></SetupOnly>,
  },
  {
    path: '/login',
    element: <GuestOnly><LoginPage /></GuestOnly>,
  },
  {
    element: <RequireAuth />,
    children: [
      { path: '/change-password', element: <ChangePasswordPage /> },
      {
        element: <RequirePasswordChanged />,
        children: [
          {
            path: '/',
            element: <AppShell />,
            children: [
              { index: true, element: <DashboardPage /> },
              { path: 'data', element: <DataIndexPage /> },
              { path: 'data/:datasetId', element: datasetDetailElement },
              { path: 'strategies', element: <StrategiesPage /> },
              { path: 'strategies/new', element: strategyBuilderElement },
              { path: 'strategies/:strategyId/edit', element: strategyBuilderElement },
              { path: 'backtests', element: <BacktestsPage /> },
              { path: 'backtests/:backtestId', element: backtestDetailElement },
              { path: 'users', element: <AdminOnly><UsersPage /></AdminOnly> },
              { path: '*', element: <Navigate to="/" replace /> },
            ],
          },
        ],
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}
